import { render } from "./DentalBridgesCare.vue?vue&type=template&id=4816cf20"
import script from "./DentalBridgesCare.vue?vue&type=script&lang=js"
export * from "./DentalBridgesCare.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__